// import Vue from 'vue'
import store from '@/store'
import index from '../components/index'
import edit from '../components/_id/edit'
import form from '../components/domain/form';

export default [
    {
        path: '/users',
        component: index,
        name: 'users',
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            if (store.state.auth.roles.includes('superadmin') || store.state.auth.roles.includes('gatekeeper') ) {
                next()
            } else {
                next({
                    name: "tickets"
                })
                return
            }
        },
    },
    {
        path: '/users/:id',
        component: edit,
        name: 'users.edit',
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            if (store.state.auth.roles.includes('superadmin') || store.state.auth.roles.includes('gatekeeper')) {
                next()
            } else {
                next({
                    name: "tickets"
                })
                return
            }
        },
    },
    {
        path: '/domain/create',
        component: form,
        name: 'domain.create',
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            if (store.state.auth.roles.includes('superadmin') || store.state.auth.roles.includes('gatekeeper')) {
                next()
            } else {
                next({
                    name: "tickets"
                })
                return
            }
        },
    },
    {
        path: '/domain/:id/edit',
        component: form,
        name: 'domain.edit',
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            if (store.state.auth.roles.includes('superadmin') || store.state.auth.roles.includes('gatekeeper')) {
                next()
            } else {
                next({
                    name: "tickets"
                })
                return
            }
        },
    }
]